import {
	mapGetters,
	mapActions
} from 'vuex';

import {
	isEmpty,
	cloneDeep
} from 'lodash';

import print from 'jQuery.print'; // eslint-disable-line
import PageBar from '@/components/page-bar/page-bar';
import FullCalendar from '@/components/calendar/fullcalendar/main';

export default {
	name: 'meal-menu-monthly',
	data: () => ({
		mealMenuClone: {},
		params: {},
		events: [],
		calendarConfig: {
			defaultDate: new Date()
		}
	}),
	components: {
		PageBar,
		FullCalendar
	},
	computed: {
		...mapGetters({
			user: 'getLoggedUser',
			mealMenu: 'mealMenu'
		})
	},
	methods: {
		...mapActions([
			'setBreadcrumb',
			'getMealMenu'
		]),
		print(target) {

			$.print(target, {
				iframe: true,
				mediaPrint: true,
				title: 'Cardápio'
			});

		}
	},
	created() {

		this.params = this.$route.params;

		if (isEmpty(this.params)) {

			return this.$router.push({
				name: 'MealMenu'
			});

		}

		this.calendarConfig = {
			defaultDate: `${ this.params.year }-${ this.params.month.index < 10 ? '0' : '' }${ this.params.month.index + 1 }-15 00:00:00`
		};

		this.setBreadcrumb([{
			text: this.$gettext('Administrativo')
		}, {
			text: this.$gettext('Cardápio')
		}, {
			text: this.$gettext('Mensal')
		}]);

	},
	mounted() {

		this.getMealMenu({
			userId: this.user.id,
			filter: {
				recipientGroup: this.params.recipientGroup,
				startDate: this.params.startDate,
				endDate: this.params.endDate
			}
		}).then(() => {

			this.mealMenuClone = cloneDeep(this.mealMenu).map((value) => {

				value.clonedDate = value.date;
				value.date = null;

				delete value.id;

				return value;

			});

			this.mealMenuClone.forEach((value) => {

				if (value.times && value.times.length) {

					value.times.forEach((item) => {

						this.events.push({
							title: `${ item.meal }. ${ item.beverage }`,
							start: `${ value.clonedDate }T${ item.time }`
						});

					});

				}

			});

		});

	}
};



// WEBPACK FOOTER //
// ./sources/app/meal-menu/monthly/index.js